import route from '@/router/index'
import Stomp from 'webstomp-client'
import {DATA, DEVICE_ID, KEY_AES, SIGN, USER_NAME} from "../constant";
import AES from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";
import {authLogout} from "../security";

const socket = (function (router) {
  let isConnected
  let connection
  let stompClient

  let connect = function (successCallback, errorCallback) {
    connection = new WebSocket(process.env.SOCKET_URI);
    stompClient = Stomp.over(connection)

    /* Disable console */
    stompClient.debug = function () {
      return '';
    }
    let currentRoute = router.currentRoute;
    let queryCurrentRoute = router.currentRoute.query;
    let _serialId = queryCurrentRoute['serialId'] || localStorage.getItem(USER_NAME);
    let _data = queryCurrentRoute['data'] || decodeAES(localStorage.getItem(DATA));
    let _sign = queryCurrentRoute['sign'] || decodeAES(localStorage.getItem(SIGN));
    if (router && currentRoute && _serialId && _data && _sign) {
      stompClient.connect(
        {
          serialId: _serialId,
          data: _data,
          sign: _sign
        },
        frame => {
          isConnected = true
          stompClient.subscribe('/errors', function () {
            // isConnected = false
          })
          successCallback(stompClient)
          localStorage.setItem(SIGN, encodeAES(_sign));
          localStorage.setItem(DATA, encodeAES(_data));
        },
        error => {
          authLogout();
          // localStorage.clear();
          errorCallback(error)
        }
      )
    }

    connection.onclose = function (e) {
      isConnected = false;
      setTimeout(function () {
        connect(successCallback, errorCallback);
      }, 5000);
    };

    connection.onerror = function (err) {
      isConnected = false;
      connection.close();
    };
  }

  let encodeAES = function (data) {
    if (data) {
      return AES.encrypt(data, KEY_AES).toString();
    }
  }

  let decodeAES = function (data) {
    if (data) {
      return AES.decrypt(data, KEY_AES).toString(enc);
    }
  }

  let sendMessage = function (path, data) {
    if (stompClient && stompClient.connected) {
      stompClient.send(path, data, {})
    }
  }

  let sendMessageSaveHistory = function (_status, _fileId, _slideShowFileId, youtubeId, _startTime, _idLayer, _typeLayer) {
    if (stompClient && stompClient.connected) {
      var dataReq = {
        deviceId: localStorage.getItem(DEVICE_ID),
        status: _status,
        fileId: _fileId,
        slideShowFileId: _slideShowFileId,
        youtubeId: youtubeId,
        startTime: _startTime,
        idLayer: _idLayer,
        typeLayer: _typeLayer
      }
      stompClient.send("/app/saveHistory", JSON.stringify(dataReq), {})
    }
  }

  let sendMessageSaveHistoryWithStartTime = function (_startTime) {
    if (stompClient && stompClient.connected) {
      var dataReq = {
        deviceId: localStorage.getItem(DEVICE_ID),
        startTime: _startTime,
      }
      stompClient.send("/app/saveHistoryWithStartTime", JSON.stringify(dataReq), {})
    }
  }

  let disconnect = function () {
    if (stompClient && stompClient.connected) {
      stompClient.disconnect()
      isConnected = false;
      router.push("/default.html")
    }
  }

  let hasConnected = function () {
    return isConnected
  }

  let init = function () {

  }

  init()

  return {
    isConnected: hasConnected,
    disconnect: disconnect,
    sendMessage: sendMessage,
    sendMessageSaveHistory: sendMessageSaveHistory,
    sendMessageSaveHistoryWithStartTime: sendMessageSaveHistoryWithStartTime,
    connect: connect
  }
})(route)

export function checkConnect() {
  return socket.isConnected()
}

export function connect(successCallback, errorCallback) {
  return socket.connect(successCallback, errorCallback)
}

export function disConnectSocket() {
  return socket.disconnect()
}

export function sendMessageSocket(path, data) {
  return socket.sendMessage(path, data)
}

export function sendMessageSaveHistory(status, fileId, slideShowFileId, youtubeId, startTime, idLayer, typeLayer) {
  return socket.sendMessageSaveHistory(status, fileId, slideShowFileId, youtubeId, startTime, idLayer, typeLayer)
}

export function sendMessageSaveHistoryWithStartTime(startTime) {
  return socket.sendMessageSaveHistoryWithStartTime(startTime)
}


// WEBPACK FOOTER //
// ./src/websocket/index.js